<span [innerHTML]='address | highlight: searchTerm'></span>
